export const OFFICIAL_IDENTIFICATION_REQUIRED_UPDATE_FIELDS = {
  VALIDITY: 'validity',
};

export const OFFICIAL_IDENTIFICATION_FIELDS = {
  ...OFFICIAL_IDENTIFICATION_REQUIRED_UPDATE_FIELDS,
  IDENTIFICATION_TYPE: 'identificationType',
  IDENTIFICATION_CODE: 'identificationCode',
};
